const style = {
  lineStyle: (startPositionX, endPositionX, startPositionY, endPositionY, angle, height) => ({
    position: 'absolute',
    left: `${(startPositionX + endPositionX) * 50}%`,
    top: `${(startPositionY + endPositionY) * 50}%`,
    width: '2px',
    height: `${height * 100}%`,
    WebkitTransform: `translate(-50%, -50%) rotate(${angle}deg)`,
    MozTransform: `translate(-50%, -50%) rotate(${angle}deg)`,
    OTransform: `translate(-50%, -50%) rotate(${angle}deg)`,
    transform: `translate(-50%, -50%) rotate(${angle}deg)`,
    filter: 'drop-shadow(0 0 20px rgba(0, 0, 0, 0.75))',
    backgroundColor: 'rgba(23, 230, 133, 0.7)',
  }),
  selectedStyle: {
    width: '4px',
    backgroundColor: '#B6F2D6',
  },
  removeButtonWrapper: {
    position: 'relative',
    height: '100%',
    width: '100%',
  },
  removeButton: {
    backgroundColor: 'red',
    width: '2vmin',
    height: '2vmin',
    borderRadius: '50%',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    border: '2px solid #B6F2D6',
    fontSize: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    cursor: 'pointer',
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Map/MapConnector/MapConnector.styles.js